// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-skeleton {
  display: grid;
  gap: var(--admin-s3);
}

.au-skeleton__block {
  position: relative;
  overflow: hidden;
  border-radius: var(--admin-radius-sm);
  background: var(--admin-bg-surface-1);
}

.au-skeleton__block::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.08) 45%, transparent 100%);
  transform: translateX(-100%);
  animation: au-skeleton-shimmer 1.25s linear infinite;
}

.au-skeleton.is-reduced-motion .au-skeleton__block::after {
  animation: none;
  transform: none;
  opacity: 0;
}

.au-skeleton__table-row {
  display: grid;
  grid-template-columns: repeat(var(--au-skeleton-columns, 4), minmax(0, 1fr));
  gap: var(--admin-s3);
}

.au-skeleton__block--table {
  height: 36px;
}

.au-skeleton__block--label {
  width: 72px;
  height: 10px;
}

.au-skeleton__block--label-gap {
  margin-top: var(--admin-s4);
}

.au-skeleton__block--row {
  height: 28px;
}

.au-skeleton__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-s4);
}

.au-skeleton__toolbar-actions {
  display: flex;
  gap: var(--admin-s2);
}

.au-skeleton__block--toolbar-label {
  width: 180px;
  height: 18px;
}

.au-skeleton__block--toolbar-button {
  width: 84px;
  height: 28px;
}

.au-skeleton__card {
  display: grid;
  gap: var(--admin-s3);
  padding: var(--admin-s5);
  border: var(--admin-border-subtle);
  border-radius: var(--admin-radius-lg);
  background: var(--admin-bg-surface-1);
}

.au-skeleton__block--card-title {
  width: 160px;
  height: 16px;
}

.au-skeleton__block--card-line {
  width: 100%;
  height: 12px;
}

.au-skeleton__block--card-line.is-short {
  width: 72%;
}

@keyframes au-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSkeleton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".au-skeleton {\n  display: grid;\n  gap: var(--admin-s3);\n}\n\n.au-skeleton__block {\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--admin-radius-sm);\n  background: var(--admin-bg-surface-1);\n}\n\n.au-skeleton__block::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.08) 45%, transparent 100%);\n  transform: translateX(-100%);\n  animation: au-skeleton-shimmer 1.25s linear infinite;\n}\n\n.au-skeleton.is-reduced-motion .au-skeleton__block::after {\n  animation: none;\n  transform: none;\n  opacity: 0;\n}\n\n.au-skeleton__table-row {\n  display: grid;\n  grid-template-columns: repeat(var(--au-skeleton-columns, 4), minmax(0, 1fr));\n  gap: var(--admin-s3);\n}\n\n.au-skeleton__block--table {\n  height: 36px;\n}\n\n.au-skeleton__block--label {\n  width: 72px;\n  height: 10px;\n}\n\n.au-skeleton__block--label-gap {\n  margin-top: var(--admin-s4);\n}\n\n.au-skeleton__block--row {\n  height: 28px;\n}\n\n.au-skeleton__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--admin-s4);\n}\n\n.au-skeleton__toolbar-actions {\n  display: flex;\n  gap: var(--admin-s2);\n}\n\n.au-skeleton__block--toolbar-label {\n  width: 180px;\n  height: 18px;\n}\n\n.au-skeleton__block--toolbar-button {\n  width: 84px;\n  height: 28px;\n}\n\n.au-skeleton__card {\n  display: grid;\n  gap: var(--admin-s3);\n  padding: var(--admin-s5);\n  border: var(--admin-border-subtle);\n  border-radius: var(--admin-radius-lg);\n  background: var(--admin-bg-surface-1);\n}\n\n.au-skeleton__block--card-title {\n  width: 160px;\n  height: 16px;\n}\n\n.au-skeleton__block--card-line {\n  width: 100%;\n  height: 12px;\n}\n\n.au-skeleton__block--card-line.is-short {\n  width: 72%;\n}\n\n@keyframes au-skeleton-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
